export const SIVU = {
    ETUSIVU:     {arvo:   0, nimi: "Etusivu"},
	TESTIRYHMÄ:  {arvo:  10, nimi: "Testiryhmä"},
	KERTOTAULUT: {arvo:  11, nimi: "Kertotaulut"},
	TESTISARJA:  {arvo:  20, nimi: "Testit"},
	TESTITIEDOT: {arvo:  30, nimi: "Testin tiedot"},
	TESTI:       {arvo:  40, nimi: "Testi"},
	TULOS:       {arvo:  45, nimi: "Testin tulos"},
	INFO:        {arvo: 100, nimi: "TIetoa ahmatista"}	
}

export const RYHMÄ = {
	KERTOTAULUT: "kertotaulu",
	HAJOTELMAT:  "hajotelma"
}

export const TYYPPI = {
	HARJOITUS:  "harjoitus",
	TESTI:      "testi"
}

export const TESTIN_TILA = {
	KESKEYTETTY: "keskeytetty",
	KÄYNNISSÄ:   "käynnissä",
	SUORITETTU:  "suoritettu"
}


// WEBPACK FOOTER //
// ./src/constants.js